<template>
    <modal @close="closeModal">
        <h1 class="modal__title">{{ type }} {{ trans('action.add') }}</h1>
        <form @submit.prevent="addMxRecordValue">
            <label class="field__label">{{ trans('page.dns.table.content') }}</label>
            <input
                v-model="form.content"
                :placeholder="trans('page.dns.table.content')"
                class="field__input | u-margin-bottom | dusk-dns-modal-content"
                ref="content"
                autofocus
            />

            <label class="field__label">{{ trans('page.dns.table.priority') }}</label>
            <input
                v-model="form.priority"
                :placeholder="trans('page.dns.table.priority')"
                class="field__input | u-margin-bottom | dusk-dns-modal-priority"
            />

            <div class="modal__nav">
                <button @click="closeModal" class="btn btn--ghost-gray btn-ghost--dns | u-margin-right">
                    {{ trans('action.cancel') }}
                </button>
                <button class="btn btn--blue-record btn-ghost--dns" type="submit">
                    {{ trans('action.save') }}
                </button>
            </div>
        </form>
    </modal>
</template>

<script>
import { Way2Form } from 'relapp-way2forms';
import { Modal } from 'relapp-modal';

export default {
    components: {
        Modal
    },
    props: {
        type: String,
        content: String,
        priority: Number
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            form: new Way2Form({
                type: this.type,
                content: this.content,
                priority: this.priority
            })
        };
    },
    /**
     * Component is mounted, set the focus on the value input.
     */
    mounted() {
        this.$refs.content.focus();
    },
    methods: {
        /**
         * Send the records to the parent component, and close the modal.
         */
        addMxRecordValue() {
            this.$emit('value', {
                type: this.form.type,
                name: this.form.name,
                content: this.form.content,
                priority: this.form.priority,
                ttl: this.form.ttl
            });
            this.$emit('close');
        },

        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        }
    }
};
</script>
